var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronLeft = function SvgIconChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.847 9.12a3 3 0 0 0-4.242 0L15.876 21.849a3 3 0 0 0-.445 3.668q.106.18.24.348.096.117.206.228L28.605 38.82a3 3 0 0 0 4.242-4.243L22.24 23.97l10.606-10.607a3 3 0 0 0 0-4.242"
  })));
};
export default SvgIconChevronLeft;